module.exports = __webpack_public_path__ + "img/booths_mobile.4afdc3ca.svg";